import { Shield } from "lucide-react"

export function Footer() {
  return (
    <footer className="border-t border-border bg-muted/50">
      <div className="mx-auto max-w-7xl px-4 py-12 lg:px-8">
        <div className="flex flex-col items-center gap-6 md:flex-row md:justify-between">
          <div className="flex items-center gap-2">
            <Shield className="size-5 text-green-700" />
            <span className="font-bold text-foreground">
              LAND<span className="text-green-700">RISK</span><sup className="text-[10px] font-semibold">™</sup>
            </span>
          </div>

          <p className="max-w-xl text-center text-xs text-muted-foreground leading-relaxed md:text-right">
            Disclaimer: LANDRISK provides advisory risk assessments only. Reports do not constitute proof of
            ownership, legal advice, or certified valuations. Always conduct independent due diligence and
            consult qualified professionals before making land investment decisions.
          </p>
        </div>

        <div className="mt-8 border-t border-border pt-6 space-y-3">
          <p className="text-center text-xs text-muted-foreground">
            LANDRISK<sup className="text-[10px]">™</sup> is a product of <span className="font-semibold">Msitu Technologies Limited</span>, 
            the premier terrestrial AI company in Africa.
          </p>
          <p className="text-center text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} LANDRISK. All rights reserved. Built for the Kenyan land market.
          </p>
        </div>
      </div>
    </footer>
  )
}
